var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    style: {
      stroke: "#748d6f",
      fill: "#486a41"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n            .cls-4,.cls-6{fill:none}.cls-4{stroke:#fff;stroke-width:2px}.cls-5{stroke:none}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    style: {
      fill: "#486a41"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_14",
    "data-name": "Mask Group 14",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    className: "cls-4",
    transform: "translate(13 8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 6.5,
    cy: 7,
    rx: 6.5,
    ry: 7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 6.5,
    cy: 7,
    rx: 5.5,
    ry: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    className: "cls-4",
    transform: "translate(6 21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 13,
    cy: 14,
    rx: 13,
    ry: 14
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 13,
    cy: 14,
    rx: 12,
    ry: 13
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImage);
export default __webpack_public_path__ + "static/media/profile-image.007f57e9.svg";
export { ForwardRef as ReactComponent };